/* eslint-disable new-cap */
import type { ColumnDef } from "@tanstack/react-table";
import type { MouseEventHandler } from "react";

import { ActionsFormatter, RoleFormatter } from "./formatters";

import { statusFormatter } from "features/vulnerabilities/formatters/status";
import type { IStakeholderDataSet } from "pages/organization/members/types";
import { formatDate } from "utils/date";
import { timeFromNow } from "utils/format-helpers";
import { translate } from "utils/translations/translate";

const getTableColumns = (
  loading: boolean,
  resendEmailHandler: (
    stakeholder: IStakeholderDataSet,
  ) => MouseEventHandler<HTMLButtonElement>,
): ColumnDef<IStakeholderDataSet>[] => [
  {
    accessorKey: "email",
    header: translate.t("tables.members.headers.email"),
    minSize: 350,
    size: 400,
  },
  {
    accessorKey: "role",
    cell: RoleFormatter,
    header: translate.t("tables.members.headers.role"),
    minSize: 150,
  },
  {
    accessorKey: "firstLogin",
    cell: (cell): string => formatDate(String(cell.getValue() ?? "")),
    header: translate.t("tables.members.headers.firstLogin"),
    minSize: 130,
  },
  {
    accessorKey: "lastActivity",
    cell: (cell): string => timeFromNow(String(cell.getValue())),
    header: translate.t("tables.members.headers.lastLogin"),
    minSize: 130,
  },
  {
    accessorKey: "invitationState",
    cell: (cell): JSX.Element => statusFormatter(String(cell.getValue())),
    header: translate.t("tables.members.headers.status"),
    minSize: 150,
  },
  {
    accessorKey: "invitationResend",
    cell: (cell): JSX.Element =>
      ActionsFormatter(cell, loading, resendEmailHandler),
    enableSorting: false,
    header: translate.t("tables.members.headers.actions"),
  },
];

export { getTableColumns };
